export default (icon?: string) => {
  if(!icon) {
    return ''
  }
  return `keep keep-${icon}`
}
